import { createFileRoute } from '@tanstack/react-router';

import { QuoteRequestsPage as PartLibraryQuoteRequestsPage } from '@/areas/quote-requests/QuoteRequests/PartLibraryQuoteRequestsPage/QuoteRequestsPage';
import { canViewPartLibrarySourcing } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/parts/_sidebar/quote-requests/')({
    staticData: { access: { permissions: canViewPartLibrarySourcing }, chrome: 'home' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <PartLibraryQuoteRequestsPage />;
}
